import React,{useState,useEffect} from 'react';
import styled from 'styled-components';
import { getCategory, setCurrentCategory, setSubCategoriesStatus, setMenuCategory } from '../../store/categories/functions';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { CONSTS } from '../elements/_constants';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useHistory } from 'react-router-dom';
import LogoWhite from '../../static/img/qclab-logo-white.svg';
import { setMenuStatus } from '../../store/base/functions';
import Link from '../elements/link';

type navigationProps = {
    className?: string,
    currentCategory: any,
    onSetCurrentCategoryId: Function,
    onToggleSubCategories:Function,
    onSetMenuStatus: Function,
    onSetMenuCategory: Function,
    currentCategoryId?:number,
    parents?: number[],
    isSubCategoriesOpen?: boolean,
    currentPathName: string,
    isMainMenuOpen: boolean
}
const LogoBarComponent = (props: navigationProps) => {
    const [isParentCategory, setIsParentCategory] = useState(false);
    let history = useHistory();
    useEffect(() => {
        if(props.currentCategory && props.currentCategoryId) {
            if(checkIsParentCategory(props.currentCategoryId)) {
                setIsParentCategory(true);
            }
        }
    }, [props.currentCategoryId])

    const checkIsParentCategory = (categoryId: number) => {
        if (!props.parents) return false;
        for (var parentId of props.parents) {
            if(parentId == categoryId) {
                return true
            }
        }
        return false
    }

    const performBack = ()=>{
        if(props.currentCategory) {
            if(props.currentCategory.parent) {
                // if(checkIsParentCategory(props.currentCategory.parent)) {
                    // props.onToggleSubCategories(!props.isSubCategoriesOpen);
                    props.onSetMenuCategory(props.currentCategory.parent);
                // } else {
                    // props.onSetMenuCategory(props.currentCategory.parent);
                // }
            }
            else {
                props.onToggleSubCategories(!props.isSubCategoriesOpen);
            }
        }
    }
    const goBack = ()=>{
        history.goBack();
    }
    return (
        <div className={props.className}>
            {props.currentCategory && props.currentCategory.id != 0 &&
                <div className="back-cat" onClick={()=>performBack()}>
                    <i className={`icon-icons8-forward ${!isParentCategory || props.isSubCategoriesOpen ? "_left" : "_right"}`}/>
                </div>
            }
            <div className="logo-bar-content">
                <SwitchTransition>
                <CSSTransition
                    key={(props.currentCategory ? props.currentCategory.id : 0) || (props.isSubCategoriesOpen && props.isSubCategoriesOpen.toString())}
                    timeout={{ enter: 300, exit: 300 }}
                    classNames="fade"
                >
                    {(!isParentCategory || props.isSubCategoriesOpen) && props.currentCategory ?
                        <div onClick={()=>history.push(`/categories/${props.currentCategoryId}`)} className="normal-title">
                            {props.currentCategory.title}
                        </div> :
                        <Link to="/">
                            <div className="head-title">
                                <img className="_logo" src={LogoWhite} />
                            </div>
                        </Link>
                    }
                </CSSTransition>
                </SwitchTransition>
            </div>
            <div className="back-cat close-main-menu" onClick={()=>props.onSetMenuStatus && props.onSetMenuStatus(!props.isMainMenuOpen)}>
                {!props.isMainMenuOpen ?
                <i className={`icon-icons8-expand_arrow`}/> :
                <i className={`icon-icons8-cancel`}/> }
            </div>
        </div>
    )
}
const mapStateToProps = (state: AppState) => ({
    currentCategory: getCategory(state.categories.items,state.categories.menuCategoryId),
    parents: state.categories.parents,
    currentCategoryId: state.categories.currentCategoryId,
    isSubCategoriesOpen: state.categories.isSubCategoriesOpen,
    currentPathName: state.base.path,
    isMainMenuOpen: state.base.isMainMenuOpen
});
  
const mapDispatchToProps = (dispatch:any) => {
    return {
        onSetCurrentCategoryId: (id: number)=>{
            dispatch(setCurrentCategory(id));
        },
        onSetMenuCategory: (categoryId: number)=>{
            dispatch(setMenuCategory(categoryId));
        },
        onToggleSubCategories: (open: boolean)=>{
            dispatch(setSubCategoriesStatus(open));
        },
        onSetMenuStatus: (isOpen: boolean)=>{
            dispatch(setMenuStatus(isOpen));
        },
    };
};

const LogoBar = styled(LogoBarComponent)`
    width: 100%;
    height: 60px;
    background:#4036C1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .back-cat {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        color: white;
        font-size: 19px;
        height: 100%;
        background: rgba(0,0,0,.08);
        cursor: pointer;
        &.close-main-menu {
            display: none;
        }
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            font-size: 1.5rem;   
            width: 65px;
            &.close-main-menu {
                display: flex;
            }
        }
        i {
            line-height: 10px;
            transition: ease transform .3s;
            &._right {
                transform: scale(-1, -1);
            }
            &._left {
                transform: scale(1, 1);
            }
        }
    }
    .logo-bar-content {
        transition: ease width .25s;
        width: ${props=>props.currentCategory && props.currentCategory.id != 0 ? "calc(100% - 50px)" : "calc(100%)"} ;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            width: calc(100% - 120px);
        }
        overflow: hidden;
        > div {
            
        }
        .normal-title {
            font-family: ${ CONSTS.fonts.primary.medium};
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1; /* number of lines to show */
            /* line-height: 20px;        fallback */
            /* max-height: 18px; */
            color: white;
            font-size: 15px;
            text-align: center;
            text-overflow: ellipsis; 
            cursor: pointer;
        }
        .head-title {
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            ._logo{
                width: 100px;
                margin: 0 auto;
            }
        }
    }
`
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogoBar);
